export const MONEY = { code: 'MONEY', name: 'msg_codes_voucherType_money_lowerCase' };
export const SUBSCRIPTION = { code: 'SUBSCRIPTION', name: 'msg_codes_productType_subscription' };
export const THIRDPARTY = { code: 'THIRDPARTY', name: 'msg_codes_voucherType_product_lowerCase' };
